import { Checkbox, Flex, Text } from '@radix-ui/themes';
import { CommonInputHint } from 'components/common/form/hint';
import { CommonInputWrapper } from 'components/common/form/wrapper';
import { t } from 'i18next';
import { ICheckboxInput } from 'interfaces/forms/checkbox';
import { RADIX } from 'lib_ts/enums/radix-ui';

export const CommonCheckboxInput = (props: ICheckboxInput) => {
  return (
    <CommonInputWrapper {...props}>
      <Flex gap={RADIX.FLEX.GAP.INPUT}>
        <Checkbox
          checked={props.checked}
          onCheckedChange={(v) => props.onChange(v === true)}
        />

        <Flex direction="column">
          <Text truncate>{props.label && t(props.label)}</Text>
          <CommonInputHint {...props} />
        </Flex>
      </Flex>
    </CommonInputWrapper>
  );
};
